/* global access:true */

access = (function() {
	'use strict';

	var instance;

	function init() {
		var objDialog = dialog();
		var getCookie = function(name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			var result = decodeURIComponent(parts.pop().split(";").shift());
			var parsedCookie;
			try {
				parsedCookie = JSON.parse(result);
			} catch (e) {
				return result;
			}
			// Return null, delete cookie if return_url set to a different site than the one the user is on
			if ( parsedCookie.sso_method !== 'ldap' && parsedCookie.return_url.indexOf(location.host) === -1 ){
				return null;
			}

			return result;
		};

		/***
		* deleteCookie
		* deletes cookie by name
		* @param {string} name - name of cookie to remove
		*/
		var deleteCookie = function(name) {
			document.cookie = name +'=; Path=/; Domain=.curriculog.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		};

		return {
			logOut: function() {
				// in re-direct sso, we want to logout on the remote IdP
				// this this effort
				var href = '/proposal';
				if ( $("#logout").attr('href') != "#" ) {
					href = $("#logout").attr('href');
				}
				$.ajax({
					url: '/session.json',
					type: 'delete',
					async: false,
					complete: function () {
						Backbone.trigger('user:logout');
						location.href = href;
					}
				});
			},

			showForm: function() {
				var dialog = objDialog.createDOMDialog('login-form', function(dialog, defaults) {
					defaults.width = 400;
					var redirect = function () {
						var windowLocation = window.location.pathname.match(/\/(.*?)\//);
						if (windowLocation !== null && windowLocation[1] === 'download-report') {
							window.location = '/reports';
						} else {
							window.location = '/';
						}
					};

					var sso_token_info = null;
					var digarc_sso_ldap = null;

					if ( sso_enabled === true ) {
						sso_token_info = getCookie('sso_token_info');
					}
					if ( digarc_sso_enabled === true ) {
						digarc_sso_ldap = 1;
					}

					// Actions
					defaults.buttons = {
						'Login': function() {
							var postParam = {
								email: $('#login-email').val(),
								password: $('#login-password').val(),
								sso_token_info: sso_token_info,
								digarc_sso_ldap: digarc_sso_ldap
							};
							var $this = $(this);
							$.post('/session.json', postParam, function(result){
								if ( result.sso_refresh === true ){
									// refresh page
									window.location.reload();
									return;
								}
								if (result.success > 0) {
									$this.dialog('close');
									window.location.reload();
									// if reload triggered a download, then redirect.
									setTimeout(redirect, 2000);
								} else {
									$('#login-failed').show();
									$('#login-password').attr('value', '');
								}
							});
						},
						Cancel: function() {
							$(this).dialog('close');
						}
					};

					dialog.find('input').on('keypress', function (event) {
						if(event.which === 13){
							event.preventDefault();
							event.stopPropagation();
							if ($(this).attr('id') === 'login-email') {
								$('#login-password').focus();
							} else {
								dialog.dialog('option', 'buttons').Login.apply(dialog);
							}
						}
					});

					defaults.close = function(event, ui) {
						$('#login-email').attr('value', '');
						$('#login-password').attr('value', '');
						$('#login-failed').hide();
					};

					$(dialog).dialog(defaults);
				});
			},

			/***
			 * checkCookie
			 * checks if the sso_token_info cookie is valid for the current site and
			 * redirects user to login/shows login form or refreshes the page to Generate
			 * new cookie if cookie is valid or invalid respectively. If sso is not
			 * enabled, show login form
			 * @param {string} redirect_url - url that user should be redirected to if cookie is valid
			 **/
			checkCookie: function(redirect_url) {
				var that = this;
				var sso_token_info;
				if ( sso_enabled === true && digarc_sso_enabled === false) {
					sso_token_info = getCookie('sso_token_info');
					if ( sso_token_info ) {
						var postParam = {
							'sso_token_info': sso_token_info
						};

						$.post('/dssog/check.json', postParam, function(result){
							if ( result.sso_refresh === true ) {
								deleteCookie('sso_token_info');
								window.location.reload();
							} else {
								sso_token_info = JSON.parse(sso_token_info);

								if ( sso_token_info.sso_method === 'ldap' ) {
									that.showForm();
								} else {
									window.location = redirect_url;
								}
							}
						});
					} else {
						deleteCookie('sso_token_info');
						window.location.reload();
					}
				} else {
					if (redirect_url !== '#') {
						window.location = redirect_url;
					} else {
						that.showForm();
					}
				}
			}
		};
	};

	return {
		getInstance: function() {
			if (!instance) {
				instance = init();
			}
			return instance;
		}
	};
})();
